import mapFunction from './mapResources';

export default mapFunction('group_history', {
    isFetching: false,
    items: []
});